import { render, staticRenderFns } from "./cheliangguiji.vue?vue&type=template&id=7dd36a8a&scoped=true&"
import script from "./cheliangguiji.vue?vue&type=script&lang=js&"
export * from "./cheliangguiji.vue?vue&type=script&lang=js&"
import style0 from "./cheliangguiji.vue?vue&type=style&index=0&id=7dd36a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd36a8a",
  null
  
)

export default component.exports